export const networkJobsActionTypes = {
    'PAGE_INIT': 'NETWORK_JOBS_PAGE_INIT',
    'PAGE_NEXT': 'NETWORK_JOBS_PAGE_NEXT',
    'PAGE_PREVIOUS': 'NETWORK_JOBS_PAGE_PREVIOUS',
    'PAGE_REQUEST': 'NETWORK_JOBS_PAGE_REQUEST',
    'PAGE_SUCCESS': 'NETWORK_JOBS_PAGE_SUCCESS',
    'PAGE_ERROR': 'NETWORK_JOBS_PAGE_ERROR',
    'TOGGLE_SELECTION': 'NETWORK_JOBS_TOGGLE_SELECTION',
    'CLEAR_SELECTION': 'NETWORK_JOBS_CLEAR_SELECTION',
    'TOGGLE_ALL': 'NETWORK_JOBS_TOGGLE_ALL',
    'ADD_FILTER': 'NETWORK_JOBS_ADD_FILTER',
    'REMOVE_FILTER': 'NETWORK_JOBS_REMOVE_FILTER',
};
